import { api } from "./client";

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "/api";

// Payment System v3.0 (WS1) — Servicer Instruction Report API client. The
// INVERSE of the PIR (servicer-channel disbursement lines, batched per period).

export type ServicerInstructionFormat = "csv" | "pdf";
export type ServicerInstructionScope = "AllLive" | "Loan" | "Pool";

export interface ServicerInstructionListItem {
  id: string;
  reportNumber: string;
  loanId: string | null;
  poolId: string | null;
  dateRangeStart: string | null;
  dateRangeEnd: string | null;
  generatedAt: string;
  generatedByUserId: string;
  format: ServicerInstructionFormat | string;
  totalDisbursements: number;
  totalAmount: number;
}

export interface ServicerInstructionLine {
  disbursementId: string;
  paymentId: string;
  paymentDate: string;
  loanId: string | null;
  loan: string;
  recipientEntityId: string | null;
  recipient: string;
  recipientAccount: string;
  recipientBank: string;
  recipientAba: string;
  recipientAccountNumber: string;
  amount: number;
  obligation: string;
}

export interface ServicerInstructionPeriod {
  period: string;
  totalAmount: number;
  lines: ServicerInstructionLine[];
}

export interface ServicerInstructionDetail extends ServicerInstructionListItem {
  periods: ServicerInstructionPeriod[];
}

export interface ServicerInstructionGenerateRequest {
  scope: ServicerInstructionScope;
  rangeStart?: string | null;
  rangeEnd?: string | null;
  format: ServicerInstructionFormat;
  loanId?: string | null;
  poolId?: string | null;
}

export const servicerInstructionsApi = {
  list: () =>
    api.get<ServicerInstructionListItem[]>("/servicer-instructions"),
  get: (id: string) =>
    api.get<ServicerInstructionDetail>(`/servicer-instructions/${id}`),
  generate: (req: ServicerInstructionGenerateRequest) =>
    api.post<ServicerInstructionListItem>("/servicer-instructions/generate", req),
  downloadCsv: async (id: string): Promise<Blob> => {
    const resp = await fetch(`${API_BASE}/servicer-instructions/${id}/csv`, {
      credentials: "include",
    });
    if (!resp.ok) throw new Error(`Download CSV failed (${resp.status})`);
    return resp.blob();
  },
  downloadPdf: async (id: string): Promise<Blob> => {
    const resp = await fetch(`${API_BASE}/servicer-instructions/${id}/pdf`, {
      credentials: "include",
    });
    if (!resp.ok) throw new Error(`Download PDF failed (${resp.status})`);
    return resp.blob();
  },
};

export function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
